module.exports = __webpack_public_path__ + "static/LFS0089-WebBanners-Header-Image[6]-7b2a67ee40b7058428a79c83283d22b2.png";